/**
 * 是否是人员节点
 */
export const isUserNode = (type?: string) => {
  return type === 'USER'
}
